<template>
    <ListenerPlaylistLibrary v-if="isListenerMobile" />
    <PlaylistLibrary v-else />
</template>

<script>
import PlaylistLibrary from './PlaylistLibrary.vue'
import ListenerPlaylistLibrary from './ListenerPlaylistLibrary.vue'

export default {
    name: 'playlists',
    components: {
        PlaylistLibrary,
        ListenerPlaylistLibrary
    },
    computed: {
        isListenerMobile() {
            return !this.$store.state.common.isSuperuser
                && typeof window !== 'undefined'
                && window.innerWidth <= 768
        }
    }
}
</script>
